export enum ReportType {
    Company = 1,
    BusinessPartner = 2
}

export enum ReportSubType{
    Company = 1,
    BusinessPartner = 2,
    BusinessPartnerInternal = 3,
    BusinessPartnerSupplier  = 4
}